import React, { PureComponent } from "react";

import Parser from "html-react-parser";
import { Icon } from "@tvg/design-system";

import {
  PromoInfoStepContainer,
  PromoIconContainer,
  PromoDetailContainer,
  PromoStepNumber,
  PromoStepDescription
} from "./styled-components";

const renderIcon = (name) => {
  return (
    <Icon
      name={name}
      size="s"
      lineColor="content.mtp"
      shouldUseColorTokens
      overrideSize={parseFloat(getComputedStyle(document.body).fontSize) * 3}
      style={{ zIndex: 1 }}
    />
  );
};

export default class PromoInfoStep extends PureComponent {
  static defaultProps = {
    content: {
      id: undefined,
      iconName: undefined,
      stepNumber: undefined,
      stepTitle: undefined,
      stepDescription: undefined
    },
    qaLabel: "promoInfoStep"
  };

  render() {
    const { content, qaLabel } = this.props;

    return (
      <PromoInfoStepContainer data-qa-label={qaLabel}>
        <PromoIconContainer data-qa-label={`${qaLabel}Icon`}>
          {content.iconName && renderIcon(content.iconName.icon)}
        </PromoIconContainer>
        <PromoDetailContainer data-qa-label={`${qaLabel}DetailContainer`}>
          <PromoStepNumber data-qa-label={`${qaLabel}StepNumber`}>
            {content.stepNumber}
          </PromoStepNumber>
          <PromoStepDescription data-qa-label={`${qaLabel}StepDescription`}>
            {Parser(content.stepDescription)}
          </PromoStepDescription>
        </PromoDetailContainer>
      </PromoInfoStepContainer>
    );
  }
}
